import mockAxios, { AxiosResponse } from 'axios';
import { ITariffMandatoryItemServiceMock } from './tariff-mandatory-item.mock.types';

export const mockTariffMandatoryItemService = (): ITariffMandatoryItemServiceMock => ({
  fetchTariffMandatoryItems: jest.fn(),
  fetchTariffMandatoryItem: jest.fn(),
  createTariffMandatoryItem: jest.fn(),
  updateTariffMandatoryItem: jest.fn(),
  deleteTariffMandatoryItem: jest.fn()
});

export function mockTariffMandatoryItemAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
